<template>
    <div>
        <breadcrumbs>
            Scrapers pages
        </breadcrumbs>

        <div class="flex justify-between items-center">
            <div>
                <h1 class="text-5xl text-teal-800 truncate">
                    Scraper pages
                </h1>
            </div>

            <div class="flex justify-end">
                <inertia-link
                    :href="route('admin.scraperpages.downloadall')"
                    method="get"
                    class="group bg-white px-3 py-2 rounded text-teal-800 hover:text-teal-200 hover:bg-teal-800"
                    @click="downloadAll"
                    preserve-scroll
                    preserve-state
                >
                    <i class="fad mr-1 text-teal-600 group-hover:text-teal-200" :class="loading == 'downloadall' ? 'fa-spinner fa-pulse' : 'fa-download'"></i>Download &amp; parse
                    all
                </inertia-link>

                <inertia-link
                    :href="route('admin.scraperpages.parseall')"
                    method="patch"
                    class="group bg-white ml-3 px-3 py-2 rounded text-teal-800 hover:text-teal-200 hover:bg-teal-800"
                    @click="parseAll"
                    preserve-scroll
                    preserve-state
                >
                    <i class="fad mr-1 text-teal-600 group-hover:text-teal-200" :class="loading == 'parseall' ? 'fa-spinner fa-pulse' : 'fa-layer-plus'"></i>Parse & persist all
                </inertia-link>
            </div>
        </div>

        <scraper-runs-table :scraper-runs="scraperRuns"></scraper-runs-table>

        <scraper-pages-table :pages="pages" :filters="filters" class="mt-5" />
    </div>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Layout from "@/admin/Shared/Layout";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import ScraperPagesTable from "@/admin/Components/Scrapers/ScraperPagesTable";
import ScraperRunsTable from "@/admin/Components/Scrapers/ScraperRunsTable";

export default {
    metaInfo: {
        title: "Scraper pages"
    },

    layout: Layout,

    mixins: [Helpers],

    components: {
        Breadcrumbs,
        ScraperPagesTable,
        ScraperRunsTable
    },

    props: {
        pages: Object,
        scraperRuns: Array,
        filters: Object
    },

    methods: {
        downloadAll() {
            this.setTempLoading("downloadAll");
            // this.$eventHub.$emit("set-reloading", true);
        },
        parseAll() {
            this.setTempLoading("parseAll");
            // this.$eventHub.$emit("set-reloading", true);
        }
    }
};
</script>
